<template>
    <rkm-form
        v-if="model"
        ref="RkmForm"
        show-legend
    >
        <rkm-row>
            <rkm-col cols="5">
                <rkm-form-input
                    :validations="validations.nome"
                    label="Nome"
                    v-model="model.nome"
                />
            </rkm-col>

            <rkm-col cols="5">
                <rkm-form-select
                    :options="form.tipos"
                    :validations="validations.tipo"
                    label="Tipo"
                    show-default-option
                    text-field="nome"
                    v-model="model.tipoId"
                    value-field="id"
                />
            </rkm-col>

            <rkm-col cols="2">
                <rkm-form-input
                    :validations="validations.grau"
                    label="Grau de prioridade"
                    number
                    v-model="model.grau"
                />
            </rkm-col>
        </rkm-row>
    </rkm-form>
</template>

<script>
// Mixins.
import {error, repository, stringCase} from '@/mixins'

// Vuex.
import {mapActions} from 'vuex'

export default {
    computed: {
        validations() {
            return {
                nome: {
                    required: true,
                    min: 3,
                    max: 100,
                },
                tipo: {required: true},
                grau: {
                    required: true,
                    min_value: 0,
                    max_value: 6,
                },
            }
        },
    },
    created() {
        this.repositories = {
            prioridade: this.getConectaSusRepository('painelSenha.prioridade')
        }
    },
    data: () => ({
        form: null,
        model: null,
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {
            this.setLoading()

            if (this.id) {
                this.repositories.prioridade.edit(this.id)
                    .then(response => {
                        this.form = Object.assign(response.data.form)
                        this.model = Object.assign(response.data.model)
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            } else {
                this.repositories.prioridade.create()
                    .then(response => {
                        this.form = Object.assign(response.data.form)
                        this.model = Object.assign(response.data.model)
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            }
        },
        save() {
            this.$refs.RkmForm.validate()
                .then(valid => {
                    if (!valid) return

                    this.setLoading()

                    const request = {
                        tipoId: this.model.tipoId,
                        nome: this.model.nome,
                        grau: this.model.grau,
                    }

                    if (this.id) {
                        this.repositories.prioridade.update(this.id, this.camelObjectKeysToSnakeRecursive(request))
                            .then(response => {
                                this.showSaveNotification()
                                this.$emit('save', response)
                            })
                            .catch(this.handleError)
                            .finally(() => this.unsetLoading())
                    } else {
                        this.repositories.prioridade.store(this.camelObjectKeysToSnakeRecursive(request))
                            .then(response => {
                                this.showSaveNotification()
                                this.$emit('save', response)
                            })
                            .catch(this.handleError)
                            .finally(() => this.unsetLoading())
                    }
                })
        },
    },
    mixins: [error, repository, stringCase],
    mounted() {
        this.load()
    },
    props: {
        id: {type: [Number, String], default: null},
    },
}
</script>